import React from "react";

import ColumnsOffset from "./ColumnsOffset";

type RowSearchAndFiltersProps = {
  children: React.ReactNode;
};

const RowSearchAndFilters: React.FC<RowSearchAndFiltersProps> = ({ children }) => {
  return (
    <div className="row">
      <div className="container mb-12 shadow-tab sm:shadow-none">
        <div className="row -mx-8 sm:-mx-4">
          <div className="px-0 sm:px-4">
            <div className="flex flex-col bg-light sm:flex-row sm:items-center sm:rounded sm:shadow-tab">
              <ColumnsOffset col="22" offset="1">
                {children}
              </ColumnsOffset>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowSearchAndFilters;
